<button
  class="btn btn-debug btn-block"
  (click)="open()"
  appAnalyticsClick="Meta:Debug"
  appSfx="ui-click"
  [sfxOffset]="3"
  [sfxTrigger]="['click', 'hover']"
>
  Content Analysis
</button>
